import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Response2ResponseData } from "./common";
/**
 * Getters
 */
export const _ImageGetter = Getter.of();
export const _ImagesGetter = Getter.of();
export const _ImageResponseGetter = Getter.of();
export const _ImagesResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _ImageResponse2Image = _Response2ResponseData();
export const _ImagesResponse2Images = Fold.mapF((res) => Res.map((x) => x.data, res));
export const _Image2Data = Fold.compose(_ImageGetter, Res._Response());
export const _Image2Attributes = Fold.compose(_Image2Data, Lens.prop("attributes"));
export const _ImageAttributes2Alias = Fold.compose(_Image2Attributes, Lens.prop("alias"));
export const _ImageAttributes2Kind = Fold.compose(_Image2Attributes, Lens.prop("kind"));
export const _ImageAttributes2Default = Fold.compose(_Image2Attributes, Lens.prop("default"));
export const _ImageAttributes2Height = Fold.compose(_Image2Attributes, Lens.prop("height"));
export const _ImageAttributes2Width = Fold.compose(_Image2Attributes, Lens.prop("width"));
export const _ImageAttributes2Src = Fold.compose(_Image2Attributes, Lens.prop("src"));
export const _ImageAttributes2Title = Fold.compose(_Image2Attributes, Lens.prop("title"));
export const _ImageAttributes2Description = Fold.compose(_Image2Attributes, Lens.prop("description"));
export const _ImageAttributes2CropCenter = Fold.compose(_Image2Attributes, Lens.prop("cropCenter"));

